decodedKey